import { PaymentsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/payment-wrapper';

export function MasterCardIcon(props: PaymentsProps) {
  return (
    <SvgWrapper {...props}>
      <g fill="none" fillRule="evenodd">
        <rect
          x={0.5}
          y={0.5}
          width={35}
          height={23}
          rx={4}
          fill="#FFF"
          stroke="#CFD4D9"
        />
        <g fillRule="nonzero">
          <path fill="#FF5F00" d="M14.684 6.977h6.085v9.938h-6.085z" />
          <path
            d="M15.311 11.946a6.31 6.31 0 0 1 2.414-4.968 6.32 6.32 0 1 0 0 9.938 6.31 6.31 0 0 1-2.414-4.97Z"
            fill="#EB001B"
          />
          <path
            fill="#F79E1B"
            d="M27.347 15.863v-.204h.087v-.042h-.209v.042h.083v.204zM27.752 15.863v-.246h-.063l-.074.176-.074-.176h-.063v.246h.046v-.186l.068.16h.048l.068-.16v.186zM27.95 11.946a6.32 6.32 0 0 1-10.225 4.968 6.32 6.32 0 0 0 0-9.937 6.32 6.32 0 0 1 10.225 4.968v.001Z"
          />
        </g>
      </g>
    </SvgWrapper>
  );
}
